export default {
  props: {
    baseWidth: {
      type: Number,
      required: true,
    },
    baseHeight: {
      type: Number,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },

  computed: {
    extraMods() {
      return [];
    },
    mod() {
      return [...this.extraMods, ...(this.content.mod || [])];
    },
    classes() {
      return [
        this.$options.name,
        this.content.action ? `${this.$options.name}--hotspot` : false,
        ...this.mod.map((c) => `${this.$options.name}--${c}`),
      ];
    },
    size() {
      const propSize = this.content.size || {};
      return this.content?.position === "center"
        ? { ...propSize, left: "50%", top: "50%" }
        : propSize;
    },
    transform() {
      const transform = [];
      if (this.content?.position == "center") {
        transform.push("translate(-50%, -50%)");
      } else if (typeof this.content?.transform === "object") {
        for (const [key, value] of Object.entries(this.content.transform)) {
          transform.push(`${key}(${value})`);
        }
      }
      return transform.join(" ");
    },
    styles() {
      const axis = {
        left: "x",
        right: "x",
        width: "x",
        top: "y",
        height: "y",
        bottom: "y",
      };

      const styles = {};

      for (const [key, value] of Object.entries(this.size)) {
        if (typeof value === "string") {
          styles[key] = value;
        } else {
          styles[key] = this.computeSize(value, axis[key]) + "%";
        }
      }

      return {
        ...styles,
        transform: this.transform,
      };
    },
  },

  methods: {
    computeSize(x, axis = "x") {
      return (x * 100) / (axis === "x" ? this.baseWidth : this.baseHeight);
    },
  },

  mounted() {
    if (this.$options.name) {
      this.$emit("init", this.content.id);
    }
  },
};
